import { createFileRoute } from '@tanstack/react-router';
import { CourseStudySHView } from '@/course-study/CourseStudySHView';
import { CourseStudyStudentView } from '@/course-study/CourseStudyStudentView';
import { useCourseStudyAccess } from '~/hooks/useCourseStudyAccess';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/',
)({
  component: CourseProgressionScreen,
});

function CourseProgressionScreen() {
  const { memberId } = Route.useParams();
  // The subject relation, not `useCurrentUser().isStudyHelper`: legacy hands a
  // plain student their own Courses screen and every supervisor the Course
  // Progression accordion, regardless of what the viewer's own profile type is
  // (`class-course-study.php:28-49`).
  //
  // The shell (`$memberId.course-study.tsx`) renders no <Outlet/> until this same
  // query has resolved and `can_view` is true, so by the time this route mounts
  // the answer is already cached and there is no branch flicker.
  const { access } = useCourseStudyAccess(memberId);
  const studentId = Number(memberId);

  return access?.is_supervisor ? (
    <CourseStudySHView studentId={studentId} />
  ) : (
    <CourseStudyStudentView studentId={studentId} />
  );
}
